import { render, staticRenderFns } from "./NuevaGerencia.vue?vue&type=template&id=7f958729&"
import script from "./NuevaGerencia.vue?vue&type=script&lang=js&"
export * from "./NuevaGerencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports